import { useCallback, useEffect, useRef, useState } from "react";
export const useHighlightState = ({ options, onSelect, }) => {
    const [highlighted, setHighlighted] = useState("");
    // We saves highlighted value without updates link for event listener
    const highlightedRef = useRef(highlighted);
    useEffect(() => {
        highlightedRef.current = highlighted;
    }, [highlighted]);
    const [controlledHighlight, setControlledHighlight] = useState(true);
    const setHighlight = useCallback((step) => {
        setHighlighted((prev) => {
            const currentIndex = options.findIndex((opt) => opt.value === prev);
            if (currentIndex === -1) {
                return options[0]?.value || "";
            }
            else {
                const newHighlighted = options[currentIndex + step]?.value;
                return newHighlighted || options[currentIndex]?.value || "";
            }
        });
        setControlledHighlight(true);
    }, [options, setHighlighted]);
    const handleKeyDown = useCallback((e) => {
        if (e.code === "ArrowUp") {
            e.preventDefault();
            setHighlight(-1);
        }
        else if (e.code === "ArrowDown") {
            e.preventDefault();
            setHighlight(+1);
        }
        else if (e.code === "Enter") {
            e.preventDefault();
            onSelect(highlightedRef.current);
        }
    }, [onSelect, setHighlight]);
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleKeyDown]);
    const getOptionsIsHighlighted = useCallback((option) => {
        return controlledHighlight && option.value === highlighted;
    }, [controlledHighlight, highlighted]);
    return {
        highlighted,
        controlledHighlight,
        setControlledHighlight,
        getOptionsIsHighlighted,
    };
};
